<template>
  <span v-if="label">
    <template v-if="isRequired">
      {{ preparedLabel }}<span class="required-asterisk">*</span>:
    </template>
    <template v-else>{{ label }}</template>
  </span>
</template>

<script>
export default {
  props: {
    label: String,
  },
  computed: {
    isRequired() {
      return this.label.endsWith("*:");
    },
    preparedLabel() {
      return this.label.replace("*:", "");
    },
  },
};
</script>

<style lang="scss" scoped>
.required-asterisk {
  color: $error-color;
}
</style>
